import Cookies from 'js-cookie';

import actions from '@/store/modules/user/actions'
import getters from '@/store/modules/user/getters';
import mutations from '@/store/modules/user/mutations'
import { safeParseJSON } from '@/utils/safeParseJSON'


function resolveSetPanelFromCookie() {
    const panel = Cookies.get('setPanel');
    if (!panel || panel === '0') {
        return null;
    }
    const user = safeParseJSON('user', {});
    const roles = Array.isArray(user.roles) ? user.roles : [];
    const isClientOnly = roles.some((role) => role.name === 'Client')
        && !roles.some((role) => role.name === 'Seller' || role.name === 'Admin');

    // O contexto persistido não é uma autorização. Client-only precisa
    // redescobrir os pais confirmados pelo endpoint de painéis.
    if (isClientOnly) {
        Cookies.remove('setPanel');
        Cookies.remove('setPanelName');
        Cookies.remove('setPanelPermission');
        localStorage.removeItem('subUser');
        localStorage.removeItem('active_sub_user_id');
        return null;
    }

    if (user.id != null && String(panel) === String(user.id)) {
        Cookies.remove('setPanel');
        Cookies.remove('setPanelName');
        Cookies.remove('setPanelPermission');
        return null;
    }
    return panel;
}

const state = {
    user: safeParseJSON('user', {}),
    verifyEmail: (String(Cookies.get('verify_email')) == "true"),
    userClub: (String(Cookies.get('club_integration')) == "true"),
    setPanel: resolveSetPanelFromCookie(),
    availablePanels: [],
}


export {
    state,
    getters,
    actions,
    mutations,
}
